import React, { Component } from "react";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Tab } from "semantic-ui-react";

/**
 * Imports all settings panes.
 */
import SystemPane from "./SystemPane";
import AppearancePane from "./AppearancePane";

/**
 * Imports the settings application stylesheet.
 */
import "./Settings.css";

/**
 * Settings : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Settings application module, which controlls its panes
 * via a tab menu.
 */
class Settings extends Component {
  state = {};

  /**
   * Rendered tab menu items to display settings panes.
   */
  panes = [
    {
      menuItem: {
        key: "system",
        icon: "computer",
        content: this.props.intl.formatMessage({
          id: "settings.system.title"
        })
      },
      render: () => <SystemPane />
    },
    {
      menuItem: {
        key: "appearance",
        icon: "paint brush",
        content: this.props.intl.formatMessage({
          id: "settings.appearance.title"
        })
      },
      render: () => <AppearancePane />
    }
  ];

  render() {
    return (
      <div className="settings-view">
        <h2>
          <FormattedMessage
            id="settings.application.title"
            description="Settings application title"
          />
        </h2>
        <Tab
          menu={{ fluid: true, vertical: true, secondary: true }}
          menuPosition="left"
          panes={this.panes}
        />
      </div>
    );
  }
}

Settings.propTypes = {
  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired
};

export default injectIntl(Settings);



// WEBPACK FOOTER //
// ./src/modules/settings/Settings.js